// import { Component, OnInit } from '@angular/core';
// import { Router, NavigationStart, NavigationCancel, NavigationEnd } from '@angular/router';
// import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
// import { filter } from 'rxjs/operators';
// import { AuthService } from './services/auth.service';
// import { AccountService } from './services/account.service';
// import { UtilsService } from './services/utils.service';
// import { LocationService } from './services/location.service';
// declare let $: any;

// @Component({
//     selector: 'app-root',
//     templateUrl: './app.component.html',
//     styleUrls: ['./app.component.css'],
//     providers: [
//         Location, {
//             provide: LocationStrategy,
//             useClass: PathLocationStrategy
//         }
//     ]
// })
// export class AppComponent implements OnInit {
//   location: any;
//   routerSubscription: any;
//   noScrollRoutes = ["/#employeur", "/#employe", "/#allocataire"];
//   loaderVisible:boolean = false;
//   userInconnu: string;
//   constructor(
//     private router: Router,
//     private authService: AuthService,
//     private accountService: AccountService,
//     private utilsService: UtilsService,
//     private locationService: LocationService
//   ) 
//   {
//     this.initierAutoConnexion();
//     // this.locationService.initializeLocation();
//   }

//   ngOnInit(){
//       this.recallJsFuntions();
//   }

//   recallJsFuntions() {
//       this.router.events
//       .subscribe((event) => {
//           if ( event instanceof NavigationStart ) {
//             if(this.noScrollRoutes.indexOf(event.url) == -1){
//               $('.preloader').fadeIn('slow');
//             }
//           }
//       });
//       this.routerSubscription = this.router.events
//       .pipe(filter(event => event instanceof NavigationEnd || event instanceof NavigationCancel))
//       .subscribe(event => {
//         if(this.noScrollRoutes.indexOf(this.router.url) == -1){
//             $.getScript('assets/js/main.js');
//             $('.preloader').fadeOut('slow');
//             this.location = this.router.url;
//             if (!(event instanceof NavigationEnd)) {
//                 return;
//             }
//             window.scrollTo(0, 0);
//         }
//       });
//   }


//     initierAutoConnexion() {
//         const existingToken = localStorage.getItem('microFinance');
//         if (!existingToken) {
//             this.autoConnecterAuDemarrage();
//         } else {
//             this.locationService.initializeLocation()
//             // this.router.navigate(['/']);
//         }
//     }
  
// autoConnecterAuDemarrage() {
//     localStorage.removeItem('microFinance');
//     this.userInconnu = "";
//     this.loaderVisible = true;
//     this.authService.autoLogin()
//         .subscribe((res) => {
//             if (res['data']) {
//                 const tokenObj = res['data'];
//                 let infos = {
//                     id: tokenObj.id,
//                     matricule: tokenObj.matricule,
//                     firstName: tokenObj.firstName,
//                     lastName: tokenObj.lastName,
//                     email: tokenObj.email,
//                     telephone: tokenObj.telephone,
//                     secteuractivite: tokenObj.secteuractivite,
//                     profession: tokenObj.profession,
//                     adresse: tokenObj.adresse,
//                     genre: tokenObj.genre
//                 }
//                 let detail = {
//                     id_token: tokenObj.access_token,
//                     refresh_token: tokenObj.refresh_token,
//                     infos: infos,
//                     authorities: tokenObj.authorities
//                 };
//                 if (res['data']['access_token']) {
//                     localStorage.setItem('microFinance', JSON.stringify(detail));
//                     this.accountService.sendAccount(JSON.stringify(infos));
//                     this.locationService.initializeLocation();
//                     this.loaderVisible = false;
//                 } 
//                 else {
//                     this.userInconnu = res['message'];
//                     this.loaderVisible = false;
//                     this.gererEchecAutoConnexion();
//                 }
//             } else {
//                 this.userInconnu = res['message'];
//                 this.loaderVisible = false;
//                 this.gererEchecAutoConnexion();
//             }
//             this.loaderVisible = false;
//         }, (err) => {
//             this.userInconnu = err['error']['message'] || err['error']['errors'][0]['message'];
//             this.loaderVisible = false;
//             this.gererEchecAutoConnexion();
//         });
// }

//  gererEchecAutoConnexion() {
//   this.utilsService.showToastError("Échec de l'auto-connexion", "Authentification");
// }

// }


import { Component, OnInit } from '@angular/core';
import { Router, NavigationStart, NavigationCancel, NavigationEnd } from '@angular/router';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { filter } from 'rxjs/operators';
import { LocationService } from './services/location.service';
import { AccountService } from './services/account.service';
declare let $: any;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    providers: [
        Location, {
            provide: LocationStrategy,
            useClass: PathLocationStrategy
        }
    ]
})
export class AppComponent implements OnInit {
  location: any;
  routerSubscription: any;
  noScrollRoutes = ["/#employeur", "/#employe", "/#allocataire"];

  constructor(
    private router: Router,
    private locationService: LocationService,
    private accountService: AccountService
  ) {
    // L'auto-connexion est gérée par APP_INITIALIZER
    // On initialise juste la localisation et l'account ici
    this.initializeAppData();
  }

  private initializeAppData() {
    // Initialiser la localisation après que le token soit disponible
    this.locationService.initializeLocation();
    
    // Envoyer les infos du compte si elles existent
    const tokenData = localStorage.getItem('microFinance');
    if (tokenData) {
      try {
        const parsed = JSON.parse(tokenData);
        if (parsed.infos) {
          this.accountService.sendAccount(JSON.stringify(parsed.infos));
        }
      } catch (e) {
       
      }
    }
  }

  ngOnInit() {
    this.recallJsFuntions();
  }

  recallJsFuntions() {
    this.router.events
      .subscribe((event) => {
        if (event instanceof NavigationStart) {
          if (this.noScrollRoutes.indexOf(event.url) == -1) {
            $('.preloader').fadeIn('slow');
          }
        }
      });

    this.routerSubscription = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd || event instanceof NavigationCancel))
      .subscribe(event => {
        if (this.noScrollRoutes.indexOf(this.router.url) == -1) {
          $.getScript('assets/js/main.js');
          $('.preloader').fadeOut('slow');
          this.location = this.router.url;
          if (!(event instanceof NavigationEnd)) {
            return;
          }
          window.scrollTo(0, 0);
        }
      });
  }
}